import { render, staticRenderFns } from "./ImportFileWrapper.vue?vue&type=template&id=a64c62ea"
import script from "./ImportFileWrapper.vue?vue&type=script&lang=js"
export * from "./ImportFileWrapper.vue?vue&type=script&lang=js"
import style0 from "./ImportFileWrapper.vue?vue&type=style&index=0&id=a64c62ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports